import React, { useEffect, useMemo, useRef, useState } from "react";
import NavBar from "../commonComponents.jsx/NavBar.jsx";
import { motion, AnimatePresence } from "framer-motion";
import Sidebar from "../components/SideBar.jsx";
import { Chart as ChartJS, ArcElement, Tooltip, Legend } from "chart.js";
import FilterPopup from "../commonComponents.jsx/FilterPopup.jsx";
import LocationDropdown from "../commonComponents.jsx/LocationDropdown.jsx";
import { useQuery } from "@tanstack/react-query";
import axios from "axios";
import CommonFooter from "../commonComponents.jsx/CommonFooter.jsx";
import MultipleLocationSuperMarketModal from "../components/MultipleLocationSuperMarketModal.jsx";
import AIAssistant from "../components/AIAssistant.jsx";
import "highcharts/highcharts-3d";
import down from "../images/address.png";
import noP from "../images/np.png";

ChartJS.register(ArcElement, Tooltip, Legend);

const ProductsList = () => {
  const [isSideBar, setIsSideBar] = useState(false);
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const [isFilterOpen, setIsFilterOpen] = useState(false);
  const today = new Date().toISOString().split("T")[0];
  const [fromDate, setFromDate] = useState(today);
  const [toDate, setToDate] = useState(today);
  const [pending, setPending] = useState();
  const [apply, setApply] = useState(0);
  const [productapply, setProductApply] = useState(0);
  const [filterLocations, setFilterLocations] = useState([]);
  const dropdownRef = useRef(null);
  const filterRef = useRef(null);
  const [searchQuery, setSearchQuery] = useState("");
  const [selectedProductId, setSelectedProductId] = useState(null);
  const [selectedPackId, setSelectedPackId] = useState(null);
  const [bottomPopup, setBottomPopup] = useState(false);
  const [showStock, setShowStock] = useState(false);
  const [zoomedImage, setZoomedImage] = useState(null);
  const [page, setPage] = useState(1);
  const pageSize = 24;

  const [isLocationModalOpen, setIsLocationModalOpen] = useState(false);
  const [Datas, setData] = useState({
    summary: [],
    locationWise: [],
  });
  const [selectedLocationID, setSelectedLocationID] = useState(null);
  const [multipleLocation, setMultipleLocations] = useState([]);

  const [searchType, setSearchType] = useState("name"); // "name" | "barcode"
  const [barcodeQuery, setBarcodeQuery] = useState("");

  const handleLocationSubmit = ({ summary, locationWise, pending }) => {
    setData({ summary, locationWise, pending });
  };

  useEffect(() => {
    const locationID = JSON.parse(sessionStorage.getItem("selectedLocation"));
    const locationList = JSON.parse(
      sessionStorage.getItem("locations") || "[]",
    );
    setSelectedLocationID(locationID);
    setMultipleLocations(locationList);
  }, []);

  const clientid = sessionStorage.getItem("clientId");
  const filteredLocationsId = filterLocations.map((item) => item.locationID);
  const locations = JSON.parse(sessionStorage.getItem("locations") || "[]");

  const adminInfo = JSON.parse(sessionStorage.getItem("adminInfo") || "{}");
  useEffect(() => {
    const hasShownModal = sessionStorage.getItem(
      "hasShownMultipleLocationModal",
    );
    const adminInfo = JSON.parse(sessionStorage.getItem("adminInfo") || "null");

    if (
      !hasShownModal &&
      adminInfo &&
      Array.isArray(adminInfo.multiple_location) &&
      adminInfo.multiple_location.length > 0
    ) {
      setIsLocationModalOpen(true);
      sessionStorage.setItem("hasShownMultipleLocationModal", "true");
    }
  }, []);

  const fetchLocations = async ({ queryKey }) => {
    const [, { clientid, locations }] = queryKey;

    const token = sessionStorage.getItem("token");

    if (!token || !clientid || locations.length === 0) {
      throw new Error("Missing required parameters");
    }

    const requestBody = {
      clientid: clientid,
      dataurl: "/api/Location",
      type: "get",
      subdata: {
        loations: locations,
      },
    };

    const response = await axios.post(
      `${process.env.REACT_APP_BACKEND_API_URL}/clients/summarydetails`,
      requestBody,
      {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      },
    );

    return response.data.result;
  };

  const shouldFetchLocations = adminInfo?.multiple_location?.length === 0;

  const { data: locationData = [] } = useQuery({
    queryKey: ["locations", { clientid, locations }],
    queryFn: fetchLocations,
    enabled: shouldFetchLocations && !!clientid && locations.length > 0,
    staleTime: 1000 * 60 * 5,
  });

  const fetchProductsList = async ({ queryKey }) => {
    const [, { clientid, page }] = queryKey;

    const token = sessionStorage.getItem("token");

    if (!token || !clientid || !fromDate || !toDate) {
      throw new Error("Missing required parameters");
    }

    const locationID =
      Array.isArray(filteredLocationsId) && filteredLocationsId.length > 0
        ? filteredLocationsId[0]
        : locationData[0]?.locationID;

    const requestBody = {
      clientid: clientid,
      type: "POST",
      dataurl: "/api/Products/SearchByString",
      subdata: {
        LocationID: locationID,
        ProductName: searchQuery,
        barcode: barcodeQuery,
        limit: pageSize,
        page: page,
      },
    };

    const response = await axios.post(
      `${process.env.REACT_APP_BACKEND_API_URL}/clients/summarydetails`,
      requestBody,
      {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      },
    );

    return response.data.result;
  };

  const {
    data: products,
    isLoading,
    isFetching,
    isFetched,
    refetch,
  } = useQuery({
    queryKey: ["products-list", { clientid, apply, page }],
    queryFn: fetchProductsList,
    enabled:
      !!clientid &&
      adminInfo?.multiple_location?.length === 0 &&
      locationData.length > 0,
    staleTime: 1000 * 60 * 5,
  });

  const productsData = products?.totalRecords ? products?.data : products;

  const fetchProductsDetailsList = async ({ queryKey }) => {
    const [, { clientid }] = queryKey;

    const token = sessionStorage.getItem("token");

    if (!token || !clientid || !fromDate || !toDate) {
      throw new Error("Missing required parameters");
    }

    const locationID =
      Array.isArray(filteredLocationsId) && filteredLocationsId.length > 0
        ? filteredLocationsId[0]
        : locationData[0]?.locationID;

    const requestBody = {
      clientid: clientid,
      type: "POST",
      dataurl: "/api/Products/SearchByID",
      subdata: {
        LocationID: locationID,
        ProductID: selectedProductId,
        PackID: selectedPackId,
      },
    };

    const response = await axios.post(
      `${process.env.REACT_APP_BACKEND_API_URL}/clients/summarydetails`,
      requestBody,
      {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      },
    );

    return response.data.result;
  };

  const {
    data: productsDetailsData,
    isFetched: isDetailsFetched,
    isLoading: isDetailsLoading,
  } = useQuery({
    queryKey: [
      "products-details-list",
      {
        clientid,
        selectedProductId,
        productapply,
        selectedPackId,
        locationData,
        filteredLocationsId,
      },
    ],
    queryFn: fetchProductsDetailsList,
    enabled:
      !!clientid &&
      adminInfo?.multiple_location?.length === 0 &&
      locationData.length > 0 &&
      !!selectedProductId,
    staleTime: 1000 * 60 * 5,
  });

  const fetchProductsStock = async ({ queryKey }) => {
    const [, { clientid }] = queryKey;

    const token = sessionStorage.getItem("token");

    if (!token || !clientid || !fromDate || !toDate) {
      throw new Error("Missing required parameters");
    }

    const locationID =
      Array.isArray(filteredLocationsId) && filteredLocationsId.length > 0
        ? filteredLocationsId[0]
        : locationData[0]?.locationID;

    const requestBody = {
      clientid: clientid,
      type: "get",
      dataurl: "/api/Products/Stock",
      subdata: {
        LocationID: locationID,
        ProductID: selectedProductId,
      },
    };

    const response = await axios.post(
      `${process.env.REACT_APP_BACKEND_API_URL}/clients/summarydetails`,
      requestBody,
      {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      },
    );

    return response.data.result;
  };

  const {
    data: productsStockData,
    isLoading: isStockLoading,
    isFetching: isStockFetching,
    isFetched: isStockFetched,
  } = useQuery({
    queryKey: [
      "products-stock-list",
      {
        clientid,
        showStock,
        selectedProductId,
        locationData,
        filteredLocationsId,
      },
    ],
    queryFn: fetchProductsStock,
    enabled:
      !!clientid &&
      adminInfo?.multiple_location?.length === 0 &&
      locationData.length > 0 &&
      !!showStock,

    staleTime: 1000 * 60 * 5,
  });

  const fetchMultipleLocations = async ({ queryKey }) => {
    const [, { selectedLocationID, multipleLocation }] = queryKey;

    const token = sessionStorage.getItem("token");

    if (!token || !selectedLocationID || locations.length === 0) {
      throw new Error("Missing required parameters");
    }

    const requestBody = {
      id: selectedLocationID,
      dataurl: "/api/Location",
      type: "get",
      subdata: {
        loations: multipleLocation,
      },
    };

    const response = await axios.post(
      `${process.env.REACT_APP_BACKEND_API_URL}/clients/multipleLocations-summarydetails`,
      requestBody,
      {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      },
    );

    return response.data.result;
  };

  const { data: multipleLocations = [], refetch: refetchLocation } = useQuery({
    queryKey: ["multi-location-list", { selectedLocationID, locations }],
    queryFn: fetchMultipleLocations,
    enabled:
      !!selectedLocationID &&
      locations.length > 0 &&
      adminInfo?.multiple_location.length >= 1,
    staleTime: 1000 * 60 * 5,
  });

  const locationDatas =
    Datas.summary.length === 0 && Datas.locationWise.length === 0
      ? locationData
      : multipleLocations;

  const clientData = JSON.parse(
    sessionStorage.getItem("clientSettings") || "null",
  );

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsDropdownOpen(false);
      }
      if (filterRef.current && !filterRef.current.contains(event.target)) {
        setIsFilterOpen(false);
      }
    };

    if (isSideBar || isDropdownOpen || isFilterOpen) {
      document.addEventListener("mousedown", handleClickOutside);
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "auto";
    }

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
      document.body.style.overflow = "auto";
    };
  }, [isSideBar, isDropdownOpen, isFilterOpen]);

  const handleProductClick = (p) => {
    // const sameProducts = productsData.filter(
    //   (item) => item.productID === p.productID,
    // );

    // if (sameProducts.length > 1) {
    //   setPackPopup({ open: true, options: sameProducts });
    // } else {
    //   setSelectedProductId(p.productID);
    //   setProductApply((prev) => prev + 1);
    //   setSelectedPackId(p.packID);
    // }
    setSelectedProductId(p.productID);
    setProductApply((prev) => prev + 1);
    setSelectedPackId(p.packID);

    setBottomPopup(true);
  };


  const getPageNumbers = (current, total) => {
  const pages = [];
  const delta = 1;
  for (let i = 1; i <= total; i++) {
    if (i === 1 || i === total || (i >= current - delta && i <= current + delta)) {
      pages.push(i);
    } else if (pages[pages.length - 1] !== "...") {
      pages.push("...");
    }
  }
  return pages;
};

  const handleApplyFilter = () => {
    setIsFilterOpen(false);
    Datas.summary.length === 0 && Datas.locationWise.length === 0
      ? refetch()
      : refetchLocation();
  };

  const handleResetFilter = () => {
    setFromDate(today);
    setToDate(today);
    setFilterLocations([]);
  };

  const fmt = (val) => val.toFixed(2);

  useEffect(() => {
    if (locationData.length === 0) return;
    setFilterLocations([locationData[0]]);
  }, [locationData]);

  const toggleLocationSelection = (location) => {
    setFilterLocations((prev) => {
      const isAlreadySelected = prev.some(
        (l) => l.locationID === location.locationID,
      );
      return isAlreadySelected ? [] : [location];
    });
  };

  const getDisplayText = (locations) => {
    if (locations.length === 0) {
      return "All Locations";
    }

    return locations.length > 2
      ? `${locations[0].locationName}, +${locations.length - 1} more`
      : locations.map((location) => location.locationName).join(", ");
  };

  return (
    <>
      <div className="min-h-[100dvh] bg-gray-50 overflow-hidden">
        <div className="max-w-[768px] mx-auto relative">
          <AnimatePresence>
            {isSideBar && (
              <>
                <motion.div
                  initial={{ opacity: 0 }}
                  animate={{ opacity: 0.5 }}
                  exit={{ opacity: 0 }}
                  transition={{ duration: 0.3 }}
                  className="fixed inset-0 bg-black z-50 "
                  onClick={() => setIsSideBar(false)}
                />
                <motion.div
                  initial={{ x: -300, opacity: 0 }}
                  animate={{ x: 0, opacity: 1 }}
                  exit={{ x: -300, opacity: 0 }}
                  transition={{
                    type: "spring",
                    stiffness: 100,
                    damping: 20,
                    duration: 0.3,
                  }}
                  className="absolute w-80 h-full overflow-hidden overflow-y-auto z-50 bg-white"
                >
                  <Sidebar
                    onHide={() => setIsSideBar(false)}
                    page={"Products List"}
                  />
                </motion.div>
              </>
            )}
          </AnimatePresence>

          <div className="bg-[#F3F3F3] rounded-3xl overflow-y-auto shadow-sm p-4 h-[100dvh]">
            <NavBar onSideBar={() => setIsSideBar(true)} />
            <div className="flex justify-between items-center mb-4">
              <div className="relative inline-block ">
                <div
                  className="
                                      bg-white/90 backdrop-blur-sm rounded-lg px-4 py-2 border border-indigo-100
                                      shadow-sm shadow-indigo-100
                                      transition-all duration-300
                                      overflow-hidden
                                  "
                >
                  <h1
                    className="
                                      text-sm 
                                      text-indigo-600
                                      relative z-10
                                      transition-all duration-300
                                      font-QBold
                                      "
                  >
                    Products List
                  </h1>
                </div>
              </div>
              {/* <button
                onClick={() => setIsFilterOpen(true)}
                className="flex items-center gap-1 bg-indigo-100 rounded-[8px] px-3 py-2 shadow-sm hover:bg-indigo-200 transition-colors"
              >
                <i className="ri-filter-line text-indigo-600"></i>
                <span className="text-sm font-QSemiBold text-indigo-700">
                  Filter
                </span>
              </button> */}
            </div>

            <div className="flex flex-col sm:flex-row items-stretch sm:items-center gap-3">
              {/* Search Bar */}

              {/* Location Selector */}
              {adminInfo?.multiple_location &&
              adminInfo.multiple_location.length > 0 ? (
                <button
                  onClick={() => setIsLocationModalOpen(true)}
                  className="px-4 py-2.5 flex items-center gap-x-2 bg-indigo-700 rounded-xl text-white text-sm font-QMedium tracking-tight whitespace-nowrap shadow-sm hover:bg-indigo-800 transition"
                >
                  Locations
                  <img src={down} className="w-4 h-4" alt="" />
                </button>
              ) : (
                <LocationDropdown
                  dropdownRef={dropdownRef}
                  isDropdownOpen={isDropdownOpen}
                  setIsDropdownOpen={setIsDropdownOpen}
                  filterLocations={filterLocations}
                  locations={locationData}
                  toggleLocationSelection={toggleLocationSelection}
                  getDisplayText={getDisplayText}
                  onApply={() => refetch()}
                />
              )}
              <div className="flex flex-col gap-2 mb-4  flex-1 max-w-sm">
                {/* Toggle */}
                <div className="flex items-center gap-1 bg-gray-100 rounded-xl p-1 w-fit">
                  <button
                    onClick={() => {
                      setSearchType("name");
                      setBarcodeQuery("");
                    }}
                    className={`px-3 py-1.5 text-xs font-QSemiBold rounded-lg transition-all duration-200
        ${searchType === "name" ? "bg-white text-indigo-600 shadow-sm" : "text-gray-500 hover:text-gray-700"}`}
                  >
                    Product Name
                  </button>
                  <button
                    onClick={() => {
                      setSearchType("barcode");
                      setSearchQuery("");
                    }}
                    className={`px-3 py-1.5 text-xs font-QSemiBold rounded-lg transition-all duration-200
        ${searchType === "barcode" ? "bg-white text-indigo-600 shadow-sm" : "text-gray-500 hover:text-gray-700"}`}
                  >
                    Barcode
                  </button>
                </div>

                {/* Input */}
                <AnimatePresence mode="wait">
                  {/* Product Name Input */}
                  {searchType === "name" && (
                    <motion.div
                      key="name"
                      initial={{ opacity: 0, y: 4 }}
                      animate={{ opacity: 1, y: 0 }}
                      exit={{ opacity: 0, y: -4 }}
                      transition={{ duration: 0.15 }}
                      className="relative flex items-center"
                    >
                      <svg
                        className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400 w-4 h-4"
                        fill="none"
                        stroke="currentColor"
                        strokeWidth="2"
                        viewBox="0 0 24 24"
                      >
                        <circle cx="11" cy="11" r="8" />
                        <path d="m21 21-4.35-4.35" />
                      </svg>
                      <input
                        type="text"
                        placeholder="Search products…"
                        value={searchQuery}
                        onChange={(e) => setSearchQuery(e.target.value)}
                        onKeyDown={(e) =>
                          e.key === "Enter" && setApply((prev) => prev + 1)
                        }
                        className="w-full pl-9 font-QRegular pr-24 py-2.5 text-sm bg-white border border-gray-200 rounded-xl shadow-sm focus:outline-none focus:ring-2 focus:ring-indigo-200 focus:border-indigo-400 transition placeholder:text-gray-400"
                      />
                      <button
                        onClick={() => setApply((prev) => prev + 1)}
                        className="absolute font-QSemiBold right-1.5 top-1/2 -translate-y-1/2 px-3 py-1.5 bg-indigo-600 hover:bg-indigo-700 text-white text-xs rounded-lg transition"
                      >
                        Search
                      </button>
                    </motion.div>
                  )}

                  {/* Barcode Input */}
                  {searchType === "barcode" && (
                    <motion.div
                      key="barcode"
                      initial={{ opacity: 0, y: 4 }}
                      animate={{ opacity: 1, y: 0 }}
                      exit={{ opacity: 0, y: -4 }}
                      transition={{ duration: 0.15 }}
                      className="relative flex items-center"
                    >
                      <svg
                        className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400 w-4 h-4"
                        fill="none"
                        stroke="currentColor"
                        strokeWidth="2"
                        viewBox="0 0 24 24"
                      >
                        <path
                          d="M3 5v14M7 5v14M11 5v14M15 5v14M19 5v14"
                          strokeLinecap="round"
                        />
                      </svg>
                      <input
                        type="text"
                        placeholder="Enter barcode…"
                        value={barcodeQuery}
                        onChange={(e) => setBarcodeQuery(e.target.value)}
                        onKeyDown={(e) =>
                          e.key === "Enter" && setApply((prev) => prev + 1)
                        }
                        className="w-full pl-9 font-QRegular pr-24 py-2.5 text-sm bg-white border border-gray-200 rounded-xl shadow-sm focus:outline-none focus:ring-2 focus:ring-indigo-200 focus:border-indigo-400 transition placeholder:text-gray-400"
                      />
                      <button
                        onClick={() => setApply((prev) => prev + 1)}
                        className="absolute font-QSemiBold right-1.5 top-1/2 -translate-y-1/2 px-3 py-1.5 bg-indigo-600 hover:bg-indigo-700 text-white text-xs rounded-lg transition"
                      >
                        Search
                      </button>
                    </motion.div>
                  )}
                </AnimatePresence>
              </div>
            </div>

            {/* <div>
              <FilterPopup
                ref={filterRef}
                isOpen={isFilterOpen}
                onClose={() => setIsFilterOpen(false)}
                fromDate={fromDate}
                setFromDate={setFromDate}
                toDate={toDate}
                setToDate={setToDate}
                locations={locationDatas}
                selectedLocations={filterLocations}
                toggleLocationSelection={toggleLocationSelection}
                getDisplayText={getDisplayText}
                onReset={handleResetFilter}
                onApply={handleApplyFilter}
              />
            </div> */}

            {/* Replace your grid section with this */}
            <AnimatePresence mode="wait">
              {/* Loading State */}
              {isLoading && (
                <motion.div
                  key="loading"
                  initial={{ opacity: 0 }}
                  animate={{ opacity: 1 }}
                  exit={{ opacity: 0 }}
                  className="grid grid-cols-1 sm:grid-cols-2 gap-4"
                >
                  {[...Array(4)].map((_, i) => (
                    <div
                      key={i}
                      className="bg-white border border-gray-200 rounded-2xl p-5 flex flex-col gap-3"
                    >
                      {/* Top Row Skeleton */}
                      <div className="flex items-start gap-3">
                        <div className="w-10 h-10 rounded-xl bg-gray-100 animate-pulse flex-shrink-0" />
                        <div className="flex-1 flex flex-col gap-2">
                          <div className="h-3.5 bg-gray-100 animate-pulse rounded-full w-4/5" />
                          <div className="h-3 bg-gray-100 animate-pulse rounded-full w-2/5" />
                        </div>
                      </div>
                      {/* Badges Skeleton */}
                      <div className="flex gap-2">
                        <div className="h-6 w-20 bg-gray-100 animate-pulse rounded-full" />
                        <div className="h-6 w-16 bg-gray-100 animate-pulse rounded-full" />
                      </div>
                      {/* Price Skeleton */}
                      <div className="flex gap-6 border-t border-gray-100 pt-3">
                        <div className="flex flex-col gap-1">
                          <div className="h-2.5 w-8 bg-gray-100 animate-pulse rounded-full" />
                          <div className="h-3.5 w-12 bg-gray-100 animate-pulse rounded-full" />
                        </div>
                        <div className="flex flex-col gap-1">
                          <div className="h-2.5 w-8 bg-gray-100 animate-pulse rounded-full" />
                          <div className="h-3.5 w-12 bg-gray-100 animate-pulse rounded-full" />
                        </div>
                        <div className="flex flex-col gap-1 ml-auto items-end">
                          <div className="h-2.5 w-14 bg-gray-100 animate-pulse rounded-full" />
                          <div className="h-3.5 w-12 bg-gray-100 animate-pulse rounded-full" />
                        </div>
                      </div>
                    </div>
                  ))}
                </motion.div>
              )}

              {/* Empty State */}
              {!isLoading &&
                !isFetching &&
                isFetched &&
                (!productsData || productsData.length === 0) && (
                  <motion.div
                    key="empty"
                    initial={{ opacity: 0, y: 10 }}
                    animate={{ opacity: 1, y: 0 }}
                    exit={{ opacity: 0 }}
                    transition={{ duration: 0.3 }}
                    className="flex flex-col items-center justify-center py-16 gap-4"
                  >
                    <div className="w-16 h-16 rounded-2xl bg-gray-50 border border-gray-200 flex items-center justify-center">
                      <svg
                        width="28"
                        height="28"
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="#d1d5db"
                        strokeWidth="1.5"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      >
                        <path d="M8 3h8l1 7c0 3.3-2.2 6-5 6s-5-2.7-5-6l1-7z" />
                        <line x1="12" y1="16" x2="12" y2="21" />
                        <line x1="9" y1="21" x2="15" y2="21" />
                      </svg>
                    </div>
                    <div className="text-center">
                      <p className="text-sm font-QSemiBold text-gray-500">
                        No products found
                      </p>
                      <p className="text-xs text-gray-400 mt-1 font-QMedium">
                        Try adjusting your search or filters
                      </p>
                    </div>
                  </motion.div>
                )}

              {/* Product Grid */}
              {!isLoading && productsData && productsData.length > 0 && (
                <motion.div
                  key="grid"
                  initial={{ opacity: 0 }}
                  animate={{ opacity: 1 }}
                  exit={{ opacity: 0 }}
                  className="grid grid-cols-1 sm:grid-cols-2 gap-4"
                >
                  {productsData.map((p, i) => {
                    return (
                      <motion.div
                        key={i}
                        initial={{ opacity: 0, y: 12 }}
                        animate={{ opacity: 1, y: 0 }}
                        transition={{
                          delay: i * 0.05,
                          type: "spring",
                          stiffness: 280,
                          damping: 24,
                        }}
                        onClick={() => handleProductClick(p)}
                        className="bg-white border border-gray-200 rounded-2xl p-5 flex flex-col gap-3 hover:border-gray-400 hover:shadow-sm transition-all duration-200 cursor-default"
                      >
                        {/* Top Row */}
                        {/* <div className="flex items-start gap-3">
                        <div className="w-10 h-10 rounded-xl bg-indigo-50 flex items-center justify-center flex-shrink-0">
                          <div className="w-10 h-10 rounded-xl bg-indigo-50 flex items-center justify-center flex-shrink-0 overflow-hidden">
                            {p?.image ? (
                              <img
                                src={`data:image/png;base64,${p.image}`}
                                alt={p.productDescription}
                                className="w-full h-full object-cover rounded-xl"
                              />
                            ) : (
                              <svg
                                width="20"
                                height="20"
                                viewBox="0 0 24 24"
                                fill="none"
                                stroke="#4338ca"
                                strokeWidth="1.6"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                              >
                                <path d="M8 3h8l1 7c0 3.3-2.2 6-5 6s-5-2.7-5-6l1-7z" />
                                <line x1="12" y1="16" x2="12" y2="21" />
                                <line x1="9" y1="21" x2="15" y2="21" />
                              </svg>
                            )}
                          </div>
                        </div>
                        <div className="flex-1 min-w-0">
                          <p className="text-sm font-QSemiBold text-gray-900 leading-snug italic line-clamp-2">
                            {p.productDescription}
                          </p>
                          <p className="text-xs font-QMedium text-gray-400 mt-1 tracking-wider">
                            {p.barcode} · ID {p.productID}
                          </p>
                        </div>
                      </div> */}
                        <div className="flex items-start gap-3">
                          <div
                            className="w-10 h-10 rounded-xl bg-indigo-50 flex items-center justify-center flex-shrink-0 overflow-hidden"
                            onClick={(e) => e.stopPropagation()}
                          >
                            {p?.image ? (
                              <>
                                <img
                                  src={`data:image/png;base64,${p.image}`}
                                  alt={p.productDescription}
                                  className="w-full h-full object-cover rounded-xl cursor-zoom-in"
                                  onClick={(e) => {
                                    e.stopPropagation();
                                    setZoomedImage(
                                      `data:image/png;base64,${p.image}`,
                                    );
                                  }}
                                />

                                {/* Zoom Modal */}
                                {zoomedImage && (
                                  <div
                                    className="fixed inset-0 z-[9999] flex items-center justify-center bg-black/70 backdrop-blur-sm"
                                    onClick={() => setZoomedImage(null)}
                                  >
                                    <div
                                      className="relative max-w-lg w-full mx-4"
                                      onClick={(e) => e.stopPropagation()}
                                    >
                                      <button
                                        onClick={() => setZoomedImage(null)}
                                        className="absolute -top-3 -right-3 z-10 w-8 h-8 bg-white rounded-full flex items-center justify-center shadow-lg text-gray-600 hover:text-gray-900"
                                      >
                                        ✕
                                      </button>
                                      <img
                                        src={zoomedImage}
                                        alt="Zoomed"
                                        className="w-full rounded-2xl shadow-2xl object-contain"
                                      />
                                    </div>
                                  </div>
                                )}
                              </>
                            ) : (
                              <svg
                                width="20"
                                height="20"
                                viewBox="0 0 24 24"
                                fill="none"
                                stroke="#4338ca"
                                strokeWidth="1.6"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                              >
                                <path d="M8 3h8l1 7c0 3.3-2.2 6-5 6s-5-2.7-5-6l1-7z" />
                                <line x1="12" y1="16" x2="12" y2="21" />
                                <line x1="9" y1="21" x2="15" y2="21" />
                              </svg>
                            )}
                          </div>
                          <div className="flex-1 min-w-0">
                            <p className="text-sm font-QSemiBold text-gray-900 leading-snug italic line-clamp-2">
                              {p.productDescription}
                            </p>
                            <p className="text-xs font-QMedium text-gray-400 mt-1 tracking-wider">
                              {p.barcode} · ID {p.productID}
                            </p>
                          </div>
                        </div>

                        {/* Badges */}
                        <div className="flex gap-2 flex-wrap">
                          <span className="text-xs font-QMedium px-2.5 py-1 rounded-full bg-indigo-50 text-indigo-700 border border-indigo-200">
                            Unit : {p.unit}
                          </span>
                          <span className="text-xs font-QMedium px-2.5 py-1 rounded-full bg-emerald-50 text-emerald-700 border border-emerald-200">
                            UOM {p.uom}
                          </span>
                        </div>

                        {/* Price Row */}
                        <div className="flex gap-6 border-t border-gray-100 pt-3">
                          <div className="flex flex-col gap-0.5">
                            <span className="text-xs uppercase tracking-widest text-gray-400 font-QSemiBold">
                              Cost
                            </span>
                            <span className="text-xs font-QMedium">
                              {fmt(p.cost)}
                            </span>
                          </div>
                          <div className="flex flex-col gap-0.5">
                            <span className="text-xs uppercase tracking-widest text-gray-400 font-QSemiBold">
                              Price
                            </span>
                            <span className="text-xs font-QMedium">
                              {fmt(p.price)}
                            </span>
                          </div>
                          <div className="flex flex-col gap-0.5 ml-auto text-right">
                            <span className="text-xs uppercase tracking-widest text-gray-400 font-QSemiBold">
                              Incl. Tax
                            </span>
                            <span className="text-xs font-QMedium">
                              {fmt(p.priceInclTax)}
                            </span>
                          </div>
                        </div>
                      </motion.div>
                    );
                  })}
                </motion.div>
              )}
              {!isLoading &&
                productsData &&
                productsData.length > 0 &&
                products?.totalPages > 1 && (
                  <div className="flex items-center justify-center gap-1.5 mt-6">
                    <button
                      type="button"
                      disabled={!products.hasPreviousPage}
                      onClick={() => setPage((p) => p - 1)}
                      className="w-9 h-9 flex items-center justify-center rounded-xl border border-gray-200 text-gray-400 hover:text-indigo-600 hover:border-indigo-300 hover:bg-indigo-50 disabled:opacity-30 disabled:hover:bg-transparent disabled:hover:border-gray-200 disabled:hover:text-gray-400 transition-all duration-200"
                    >
                      <svg
                        width="16"
                        height="16"
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="currentColor"
                        strokeWidth="2.2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      >
                        <path d="m15 18-6-6 6-6" />
                      </svg>
                    </button>

                    {getPageNumbers(
                      products.currentPageNumber,
                      products.totalPages,
                    ).map((p, idx) =>
                      p === "..." ? (
                        <span
                          key={`ellipsis-${idx}`}
                          className="w-9 h-9 flex items-center justify-center text-xs font-QMedium text-gray-300"
                        >
                          •••
                        </span>
                      ) : (
                        <button
                          key={p}
                          type="button"
                          onClick={() => setPage(p)}
                          className={`relative w-9 h-9 flex items-center justify-center rounded-xl text-xs font-QSemiBold transition-all duration-200 ${
                            products.currentPageNumber === p
                              ? "text-white shadow-md shadow-indigo-200"
                              : "text-gray-500 border border-gray-200 hover:border-indigo-300 hover:text-indigo-600 hover:bg-indigo-50"
                          }`}
                          style={
                            products.currentPageNumber === p
                              ? {
                                  background:
                                    "linear-gradient(135deg, #6366f1, #4338ca)",
                                }
                              : undefined
                          }
                        >
                          {p}
                        </button>
                      ),
                    )}

                    <button
                      type="button"
                      disabled={!products.hasNextPage}
                      onClick={() => setPage((p) => p + 1)}
                      className="w-9 h-9 flex items-center justify-center rounded-xl border border-gray-200 text-gray-400 hover:text-indigo-600 hover:border-indigo-300 hover:bg-indigo-50 disabled:opacity-30 disabled:hover:bg-transparent disabled:hover:border-gray-200 disabled:hover:text-gray-400 transition-all duration-200"
                    >
                      <svg
                        width="16"
                        height="16"
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="currentColor"
                        strokeWidth="2.2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      >
                        <path d="m9 18 6-6-6-6" />
                      </svg>
                    </button>

                    <span className="ml-3 text-[11px] font-QMedium text-gray-400 whitespace-nowrap">
                      {products.totalRecords.toLocaleString()} records
                    </span>
                  </div>
                )}
            </AnimatePresence>

            <AnimatePresence>
              {bottomPopup && (
                <>
                  {/* Backdrop */}
                  <motion.div
                    key="backdrop"
                    initial={{ opacity: 0 }}
                    animate={{ opacity: 1 }}
                    exit={{ opacity: 0 }}
                    transition={{ duration: 0.2 }}
                    onClick={() => setBottomPopup(false)}
                    className="fixed inset-0 z-40 bg-black/40 backdrop-blur-sm"
                  />

                  {/* Bottom Sheet */}
                  <motion.div
                    key="sheet"
                    initial={{ y: "100%" }}
                    animate={{ y: 0 }}
                    exit={{ y: "100%" }}
                    transition={{ type: "spring", stiffness: 320, damping: 30 }}
                    className="fixed bottom-0 left-0 right-0 z-50 bg-white rounded-t-3xl shadow-2xl pb-10 max-h-[90vh] overflow-y-auto"
                  >
                    {/* Drag Handle */}
                    <div className="sticky top-0 bg-white pt-4 pb-3 px-6 rounded-t-3xl z-10">
                      <div className="w-10 h-1 rounded-full bg-gray-200 mx-auto mb-4" />

                      {/* Header */}
                      <div className="flex items-center justify-between">
                        <p className="text-sm font-QSemiBold text-gray-900">
                          Product Details
                        </p>
                        <motion.button
                          whileHover={{ scale: 1.1 }}
                          whileTap={{ scale: 0.9 }}
                          onClick={() => {
                            setBottomPopup(false);
                            setShowStock(false);
                          }}
                          className="w-7 h-7 flex items-center justify-center rounded-lg text-gray-400 hover:text-gray-600 hover:bg-gray-100 transition"
                        >
                          <svg
                            width="15"
                            height="15"
                            viewBox="0 0 24 24"
                            fill="none"
                            stroke="currentColor"
                            strokeWidth="2.5"
                          >
                            <path d="M18 6 6 18M6 6l12 12" />
                          </svg>
                        </motion.button>
                      </div>
                    </div>

                    <div className="px-6 flex flex-col gap-5">
                      {isDetailsLoading && (
                        <motion.div
                          initial={{ opacity: 0, y: 10 }}
                          animate={{ opacity: 1, y: 0 }}
                          className="rounded-2xl border border-gray-100 p-4 flex flex-col gap-3"
                        >
                          <div className="flex items-start gap-3">
                            <div className="w-10 h-10 rounded-xl bg-gray-100 animate-pulse flex-shrink-0" />
                            <div className="flex-1 flex flex-col gap-2">
                              <div className="h-3.5 bg-gray-100 animate-pulse rounded-full w-4/5" />
                              <div className="h-3 bg-gray-100 animate-pulse rounded-full w-2/5" />
                            </div>
                          </div>
                          <div className="flex gap-2">
                            <div className="h-6 w-20 bg-gray-100 animate-pulse rounded-full" />
                            <div className="h-6 w-16 bg-gray-100 animate-pulse rounded-full" />
                          </div>
                          <div className="grid grid-cols-3 gap-2 border-t border-gray-100 pt-3">
                            {[...Array(3)].map((_, i) => (
                              <div
                                key={i}
                                className="flex flex-col gap-1.5 bg-gray-50 rounded-xl px-3 py-2"
                              >
                                <div className="h-2.5 w-10 bg-gray-100 animate-pulse rounded-full" />
                                <div className="h-4 w-14 bg-gray-100 animate-pulse rounded-full" />
                              </div>
                            ))}
                          </div>
                        </motion.div>
                      )}

                      {!isDetailsLoading &&
                        isDetailsFetched &&
                        !productsDetailsData?.productPrice && (
                          <motion.div
                            initial={{ opacity: 0, y: 10 }}
                            animate={{ opacity: 1, y: 0 }}
                            className="rounded-2xl border border-gray-100 p-8 flex flex-col items-center gap-3"
                          >
                            <div className="w-12 h-12 rounded-2xl bg-gray-50 border border-gray-200 flex items-center justify-center">
                              <svg
                                width="22"
                                height="22"
                                viewBox="0 0 24 24"
                                fill="none"
                                stroke="#d1d5db"
                                strokeWidth="1.5"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                              >
                                <path d="M8 3h8l1 7c0 3.3-2.2 6-5 6s-5-2.7-5-6l1-7z" />
                                <line x1="12" y1="16" x2="12" y2="21" />
                                <line x1="9" y1="21" x2="15" y2="21" />
                              </svg>
                            </div>
                            <div className="text-center">
                              <p className="text-sm font-QSemiBold text-gray-500">
                                No product details
                              </p>
                              <p className="text-xs font-QMedium text-gray-400 mt-1">
                                Details unavailable for this product
                              </p>
                            </div>
                          </motion.div>
                        )}
                      {!isDetailsLoading &&
                        isDetailsFetched &&
                        productsDetailsData?.productPrice && (
                          <motion.div
                            initial={{ opacity: 0, y: 10 }}
                            animate={{ opacity: 1, y: 0 }}
                            transition={{ delay: 0.1 }}
                            className="rounded-2xl border border-indigo-100 bg-gradient-to-br from-indigo-50 to-white p-4 flex flex-col gap-3"
                          >
                            {/* Product Name + Barcode */}
                            <div className="flex items-start gap-3">
                              <div className="w-10 h-10 rounded-xl bg-indigo-100 flex items-center justify-center flex-shrink-0">
                                {productsDetailsData?.productPrice?.image ? (
                                  <img
                                    src={`data:image/png;base64,${productsDetailsData.productPrice.image}`}
                                    alt={
                                      productsDetailsData.productPrice
                                        .productDescription
                                    }
                                    className="w-full h-full object-cover rounded-xl cursor-zoom-in z-[999]"
                                    onClick={(e) => {
                                      e.stopPropagation();
                                      setZoomedImage(
                                        `data:image/png;base64,${productsDetailsData.productPrice.image}`,
                                      );
                                    }}
                                  />
                                ) : (
                                  <svg
                                    width="20"
                                    height="20"
                                    viewBox="0 0 24 24"
                                    fill="none"
                                    stroke="#4338ca"
                                    strokeWidth="1.6"
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                  >
                                    <path d="M8 3h8l1 7c0 3.3-2.2 6-5 6s-5-2.7-5-6l1-7z" />
                                    <line x1="12" y1="16" x2="12" y2="21" />
                                    <line x1="9" y1="21" x2="15" y2="21" />
                                  </svg>
                                )}
                              </div>
                              <div className="flex-1 min-w-0">
                                <p className="text-sm font-QSemiBold text-gray-900 italic leading-snug">
                                  {
                                    productsDetailsData.productPrice
                                      .productDescription
                                  }
                                </p>
                                <p className="text-xs font-QMedium text-gray-400 mt-0.5 tracking-wider">
                                  {productsDetailsData.productPrice.barcode} ·
                                  ID{" "}
                                  {productsDetailsData.productPrice.productID}
                                </p>
                              </div>
                            </div>

                            {/* Badges */}
                            <div className="flex gap-2 flex-wrap">
                              <span className="text-xs font-QMedium px-2.5 py-1 rounded-full bg-indigo-100 text-indigo-700 border border-indigo-200">
                                Unit: {productsDetailsData.productPrice.unit}
                              </span>
                              <span className="text-xs font-QMedium px-2.5 py-1 rounded-full bg-emerald-50 text-emerald-700 border border-emerald-200">
                                UOM {productsDetailsData.productPrice.uom}
                              </span>
                            </div>

                            {/* Prices */}
                            <div className="grid grid-cols-3 gap-2 border-t border-indigo-100 pt-3">
                              {[
                                {
                                  label: "Cost",
                                  value: productsDetailsData.productPrice.cost,
                                },
                                {
                                  label: "Price",
                                  value: productsDetailsData.productPrice.price,
                                },
                                {
                                  label: "Incl. Tax",
                                  value:
                                    productsDetailsData.productPrice
                                      .priceInclTax,
                                },
                              ].map((item, i) => (
                                <motion.div
                                  key={item.label}
                                  initial={{ opacity: 0, y: 6 }}
                                  animate={{ opacity: 1, y: 0 }}
                                  transition={{ delay: 0.15 + i * 0.05 }}
                                  className="flex flex-col gap-0.5 bg-white rounded-xl px-3 py-2 border border-indigo-50"
                                >
                                  <span className="text-xs uppercase tracking-widest text-gray-400 font-QSemiBold">
                                    {item.label}
                                  </span>
                                  <span
                                    className={`text-sm font-QSemiBold ${item.value === 0 ? "text-gray-300" : "text-gray-900"}`}
                                  >
                                    {fmt(item.value)}
                                  </span>
                                </motion.div>
                              ))}
                            </div>
                            {/* Vendor Cost Section */}
                            {productsDetailsData?.vendorCost?.length > 0 && (
                              <motion.div
                                initial={{ opacity: 0, y: 8 }}
                                animate={{ opacity: 1, y: 0 }}
                                transition={{ delay: 0.25 }}
                                className="flex flex-col gap-2 border-t border-indigo-100 pt-3"
                              >
                                <p className="text-xs font-QSemiBold text-gray-400 uppercase tracking-widest">
                                  Vendor Cost
                                </p>
                                {productsDetailsData.vendorCost.map(
                                  (vendor, i) => (
                                    <motion.div
                                      key={i}
                                      initial={{ opacity: 0, x: -8 }}
                                      animate={{ opacity: 1, x: 0 }}
                                      transition={{
                                        delay: 0.28 + i * 0.06,
                                        type: "spring",
                                        stiffness: 300,
                                        damping: 24,
                                      }}
                                      className="flex items-center justify-between px-3 py-2.5 rounded-xl bg-white border border-indigo-50"
                                    >
                                      <div className="flex items-center gap-2.5">
                                        <div className="w-7 h-7 rounded-lg bg-indigo-50 flex items-center justify-center flex-shrink-0">
                                          <svg
                                            width="13"
                                            height="13"
                                            viewBox="0 0 24 24"
                                            fill="none"
                                            stroke="#4338ca"
                                            strokeWidth="1.8"
                                            strokeLinecap="round"
                                            strokeLinejoin="round"
                                          >
                                            <path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z" />
                                            <polyline points="9 22 9 12 15 12 15 22" />
                                          </svg>
                                        </div>
                                        <div>
                                          <p className="text-xs font-QSemiBold text-gray-700">
                                            {vendor.vendorName}
                                          </p>
                                          <p className="text-xs font-QMedium text-gray-400">
                                            {new Date(
                                              vendor.invoiceDate,
                                            ).toLocaleDateString("en-GB", {
                                              day: "2-digit",
                                              month: "short",
                                              year: "numeric",
                                            })}
                                          </p>
                                        </div>
                                      </div>
                                      <span className="text-sm font-QSemiBold text-indigo-600">
                                        {fmt(vendor.supCost)}
                                      </span>
                                    </motion.div>
                                  ),
                                )}
                              </motion.div>
                            )}
                          </motion.div>
                        )}
                      {/* Stock Button + Section */}
                      <motion.div
                        initial={{ opacity: 0, y: 10 }}
                        animate={{ opacity: 1, y: 0 }}
                        transition={{ delay: 0.18 }}
                        className="flex flex-col gap-3"
                      >
                        {/* Show Stock Button — hides when stock is visible */}
                        <AnimatePresence>
                          {!showStock && (
                            <motion.button
                              initial={{ opacity: 0, y: 6 }}
                              animate={{ opacity: 1, y: 0 }}
                              exit={{ opacity: 0, y: -6, scale: 0.95 }}
                              transition={{ duration: 0.2 }}
                              whileHover={{ scale: 1.02 }}
                              whileTap={{ scale: 0.97 }}
                              onClick={() => setShowStock(true)}
                              className="w-full flex items-center justify-center gap-2 py-3 rounded-xl border border-emerald-200 bg-emerald-50 text-emerald-700 text-sm font-QSemiBold hover:bg-emerald-100 transition"
                            >
                              <svg
                                width="15"
                                height="15"
                                viewBox="0 0 24 24"
                                fill="none"
                                stroke="currentColor"
                                strokeWidth="2"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                              >
                                <path d="M3 3h18v4H3zM3 10h18v4H3zM3 17h18v4H3z" />
                              </svg>
                              View Stock
                            </motion.button>
                          )}
                        </AnimatePresence>

                        {/* Stock Section */}
                        <AnimatePresence>
                          {showStock && (
                            <motion.div
                              initial={{ opacity: 0, height: 0 }}
                              animate={{ opacity: 1, height: "auto" }}
                              exit={{ opacity: 0, height: 0 }}
                              transition={{
                                type: "spring",
                                stiffness: 300,
                                damping: 28,
                              }}
                              className="overflow-hidden"
                            >
                              <div className="flex flex-col gap-2">
                                {/* Section Header */}
                                <div className="flex items-center justify-between">
                                  <p className="text-xs font-QSemiBold text-gray-500 uppercase tracking-widest">
                                    Stock Overview
                                  </p>
                                  <motion.button
                                    whileHover={{ scale: 1.05 }}
                                    whileTap={{ scale: 0.95 }}
                                    onClick={() => setShowStock(false)}
                                    className="text-xs font-QMedium text-gray-400 hover:text-gray-600 flex items-center gap-1 transition"
                                  >
                                    <svg
                                      width="12"
                                      height="12"
                                      viewBox="0 0 24 24"
                                      fill="none"
                                      stroke="currentColor"
                                      strokeWidth="2.5"
                                    >
                                      <path d="M18 6 6 18M6 6l12 12" />
                                    </svg>
                                    Hide
                                  </motion.button>
                                </div>

                                {/* Stock Cards */}
                                {/* Loading */}
                                {(isStockLoading || isStockFetching) && (
                                  <motion.div
                                    initial={{ opacity: 0 }}
                                    animate={{ opacity: 1 }}
                                    className="flex items-center justify-between px-4 py-3 rounded-xl bg-white border border-gray-100"
                                  >
                                    <div className="flex items-center gap-3">
                                      <div className="w-8 h-8 rounded-lg bg-gray-100 animate-pulse flex-shrink-0" />
                                      <div className="flex flex-col gap-1.5">
                                        <div className="h-3 w-32 bg-gray-100 animate-pulse rounded-full" />
                                        <div className="h-2.5 w-20 bg-gray-100 animate-pulse rounded-full" />
                                      </div>
                                    </div>
                                    <div className="flex flex-col gap-1.5 items-end">
                                      <div className="h-4 w-8 bg-gray-100 animate-pulse rounded-full" />
                                      <div className="h-3 w-14 bg-gray-100 animate-pulse rounded-full" />
                                    </div>
                                  </motion.div>
                                )}

                                {/* No data — only after fetch completes */}
                                {!isStockLoading &&
                                  !isStockFetching &&
                                  isStockFetched &&
                                  !productsStockData && (
                                    <motion.div
                                      initial={{ opacity: 0 }}
                                      animate={{ opacity: 1 }}
                                      className="flex flex-col items-center justify-center py-6 gap-2"
                                    >
                                      <div className="w-8 h-8 rounded-lg bg-gray-50 flex items-center justify-center">
                                        <svg
                                          width="14"
                                          height="14"
                                          viewBox="0 0 24 24"
                                          fill="none"
                                          stroke="#d1d5db"
                                          strokeWidth="1.8"
                                        >
                                          <path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z" />
                                          <polyline points="9 22 9 12 15 12 15 22" />
                                        </svg>
                                      </div>
                                      <p className="text-xs font-QMedium text-gray-400">
                                        No stock data available
                                      </p>
                                    </motion.div>
                                  )}

                                {/* Data — only after fetch completes */}
                                {!isStockLoading &&
                                  !isStockFetching &&
                                  isStockFetched &&
                                  productsStockData && (
                                    <motion.div
                                      initial={{ opacity: 0, x: -10 }}
                                      animate={{ opacity: 1, x: 0 }}
                                      transition={{
                                        type: "spring",
                                        stiffness: 300,
                                        damping: 24,
                                      }}
                                      className="flex items-center justify-between px-4 py-3 rounded-xl bg-white border border-gray-100 shadow-sm"
                                    >
                                      <div className="flex items-center gap-3">
                                        <div className="w-8 h-8 rounded-lg bg-emerald-50 flex items-center justify-center flex-shrink-0">
                                          <svg
                                            width="14"
                                            height="14"
                                            viewBox="0 0 24 24"
                                            fill="none"
                                            stroke="#059669"
                                            strokeWidth="1.8"
                                            strokeLinecap="round"
                                            strokeLinejoin="round"
                                          >
                                            <path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z" />
                                            <polyline points="9 22 9 12 15 12 15 22" />
                                          </svg>
                                        </div>
                                        <div>
                                          <p className="text-xs font-QSemiBold text-gray-700">
                                            {productsStockData.locationName}
                                          </p>
                                          <p className="text-xs font-QMedium text-gray-400">
                                            {productsStockData.unit} · UOM{" "}
                                            {productsStockData.uom}
                                          </p>
                                        </div>
                                      </div>
                                      <div className="flex items-center gap-1.5">
                                        <span
                                          className={`text-sm font-QSemiBold 
        ${
          productsStockData.stock > 50
            ? "text-emerald-600"
            : productsStockData.stock > 10
              ? "text-amber-500"
              : "text-red-400"
        }`}
                                        >
                                          {productsStockData.stock}
                                        </span>
                                        <span
                                          className={`text-xs px-1.5 py-0.5 rounded-full font-QMedium
        ${
          productsStockData.stock > 50
            ? "bg-emerald-50 text-emerald-600"
            : productsStockData.stock > 10
              ? "bg-amber-50 text-amber-500"
              : "bg-red-50 text-red-400"
        }`}
                                        >
                                          {productsStockData.stock > 50
                                            ? "In Stock"
                                            : productsStockData.stock > 10
                                              ? "Low"
                                              : "Critical"}
                                        </span>
                                      </div>
                                    </motion.div>
                                  )}
                              </div>
                            </motion.div>
                          )}
                        </AnimatePresence>
                      </motion.div>

                      {isDetailsLoading && (
                        <motion.div
                          initial={{ opacity: 0, y: 10 }}
                          animate={{ opacity: 1, y: 0 }}
                          className="flex flex-col gap-2"
                        >
                          <div className="h-3 w-24 bg-gray-100 animate-pulse rounded-full" />
                          {[...Array(3)].map((_, i) => (
                            <div
                              key={i}
                              className="flex items-center justify-between px-4 py-3 rounded-xl border border-gray-100"
                            >
                              <div className="flex items-center gap-3">
                                <div className="w-4 h-4 rounded-full bg-gray-100 animate-pulse" />
                                <div className="flex flex-col gap-1.5">
                                  <div className="h-3 w-20 bg-gray-100 animate-pulse rounded-full" />
                                  <div className="h-2.5 w-28 bg-gray-100 animate-pulse rounded-full" />
                                </div>
                              </div>
                              <div className="flex flex-col gap-1.5 items-end">
                                <div className="h-5 w-14 bg-gray-100 animate-pulse rounded-full" />
                                <div className="h-2.5 w-10 bg-gray-100 animate-pulse rounded-full" />
                              </div>
                            </div>
                          ))}
                        </motion.div>
                      )}
                      {!isDetailsLoading &&
                        isDetailsFetched &&
                        (!productsDetailsData?.packingBarcodes ||
                          productsDetailsData.packingBarcodes.length === 0) && (
                          <motion.div
                            initial={{ opacity: 0 }}
                            animate={{ opacity: 1 }}
                            className="flex flex-col items-center justify-center py-6 gap-2"
                          >
                            <div className="w-8 h-8 rounded-lg bg-gray-50 border border-gray-100 flex items-center justify-center">
                              <svg
                                width="14"
                                height="14"
                                viewBox="0 0 24 24"
                                fill="none"
                                stroke="#d1d5db"
                                strokeWidth="1.8"
                              >
                                <rect
                                  x="2"
                                  y="7"
                                  width="20"
                                  height="14"
                                  rx="2"
                                />
                                <path d="M16 7V5a2 2 0 0 0-4 0v2" />
                              </svg>
                            </div>
                            <p className="text-xs font-QMedium text-gray-400">
                              No packing options available
                            </p>
                          </motion.div>
                        )}

                      {/* Packing Barcodes Dropdown */}
                      {!isDetailsLoading &&
                        isDetailsFetched &&
                        productsDetailsData?.packingBarcodes?.length > 0 && (
                          <motion.div
                            initial={{ opacity: 0, y: 10 }}
                            animate={{ opacity: 1, y: 0 }}
                            transition={{ delay: 0.2 }}
                            className="flex flex-col gap-2"
                          >
                            <p className="text-xs font-QSemiBold text-gray-500 uppercase tracking-widest">
                              Select Packing
                            </p>
                            <div className="flex max-h-[500px] mb-[40px] overflow-y-auto flex-col gap-2">
                              {productsDetailsData.packingBarcodes.map(
                                (pack, i) => (
                                  <motion.button
                                    key={pack.packID}
                                    initial={{ opacity: 0, x: -8 }}
                                    animate={{ opacity: 1, x: 0 }}
                                    transition={{
                                      delay: 0.22 + i * 0.06,
                                      type: "spring",
                                      stiffness: 300,
                                      damping: 24,
                                    }}
                                    whileTap={{ scale: 0.98 }}
                                    onClick={() =>
                                      setSelectedPackId(pack.packID)
                                    }
                                    className={`flex items-center justify-between px-4 py-3 rounded-xl border transition-all duration-200 text-sm
                      ${
                        selectedPackId === pack.packID
                          ? "border-indigo-400 bg-indigo-50 shadow-sm"
                          : "border-gray-200 bg-white hover:border-indigo-200 hover:bg-indigo-50/40"
                      }`}
                                  >
                                    <div className="flex items-center gap-3">
                                      {/* Radio Dot */}
                                      <div
                                        className={`w-4 h-4 rounded-full border-2 flex items-center justify-center transition-colors
                        ${selectedPackId === pack.packID ? "border-indigo-500" : "border-gray-300"}`}
                                      >
                                        {selectedPackId === pack.packID && (
                                          <motion.div
                                            initial={{ scale: 0 }}
                                            animate={{ scale: 1 }}
                                            className="w-2 h-2 rounded-full bg-indigo-500"
                                          />
                                        )}
                                      </div>
                                      <div className="text-left">
                                        <p
                                          className={`text-sm font-QMedium ${selectedPackId === pack.packID ? "text-indigo-700" : "text-gray-700"}`}
                                        >
                                          {pack.unit}
                                        </p>
                                        <p className="text-xs font-QMedium text-gray-400 tracking-wider">
                                          {pack.barcode}
                                        </p>
                                      </div>
                                    </div>
                                    <div className="text-right">
                                      <span
                                        className={`text-xs font-QMedium px-2 py-0.5 rounded-full
                        ${selectedPackId === pack.packID ? "bg-indigo-100 text-indigo-600" : "bg-gray-100 text-gray-500"}`}
                                      >
                                        Pack {pack.packID}
                                      </span>
                                      <p className="text-xs text-gray-400 mt-0.5">
                                        UOM {pack.uom}
                                      </p>
                                    </div>
                                  </motion.button>
                                ),
                              )}
                            </div>
                          </motion.div>
                        )}

                      {/* Confirm Button */}
                      {/* <motion.button
                        initial={{ opacity: 0, y: 10 }}
                        animate={{ opacity: 1, y: 0 }}
                        transition={{ delay: 0.35 }}
                        whileHover={{ scale: 1.02 }}
                        whileTap={{ scale: 0.97 }}
                        onClick={() => {
                          setProductApply((prev) => prev + 1);
                          setBottomPopup(false);
                        }}
                        className="w-full mb-[40px] py-3.5 rounded-2xl bg-indigo-600 hover:bg-indigo-700 text-white text-sm font-QSemiBold tracking-tight transition shadow-sm"
                      >
                        Confirm Selection
                      </motion.button> */}
                    </div>
                  </motion.div>
                </>
              )}
            </AnimatePresence>

            <div className="h-20"></div>

            {/* Bottom Nav */}
            <CommonFooter page={"Department wise Sales"} />
          </div>
        </div>
        <MultipleLocationSuperMarketModal
          isOpen={isLocationModalOpen}
          fromDate={fromDate}
          toDate={toDate}
          onClose={() => setIsLocationModalOpen(false)}
          onDataSubmit={handleLocationSubmit}
          dataUrl={"Sales/DepartmentwiseAmount"}
          onPendingChange={setPending}
        />
      </div>
      <AIAssistant />
    </>
  );
};

export default ProductsList;
